import dayjs from "dayjs";
import { Stack, Typography, FormControl, InputLabel } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import StitchDatePicker from "@pd/components/StitchDatePicker";

type Props = {
  disableOnConfirmed: boolean;
  serviceDate: string;
  onChange: (name: string, value: string) => void;
};
export default function ServiceDateInput(props: Props) {
  const dateValue =
    props.serviceDate && dayjs(props.serviceDate).isValid()
      ? dayjs(props.serviceDate).toDate()
      : null;

  return (
    <Stack spacing={1} sx={{ mt: "25px", pl: "65px" }}>
      <InputLabel htmlFor="serviceDate">
        <Stack direction="row" alignItems="center" gap={0.5}>
          <Typography>Service date</Typography>
          <Typography variant="subtitle2" sx={{ pt: "6px" }}>
            *
          </Typography>
        </Stack>
      </InputLabel>
      <FormControl fullWidth>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StitchDatePicker
            value={dateValue}
            onChange={(date: Date | null) => {
              if (date && dayjs(date).isValid()) {
                const serviceDate = date.toISOString();
                props.onChange("serviceDate", serviceDate);
              }
            }}
            disabled={props.disableOnConfirmed}
            onClear={() => props.onChange("serviceDate", "")}
          />
        </LocalizationProvider>
      </FormControl>
    </Stack>
  );
}
